// Utility for managing referral code in localStorage
export class ReferralManager {
  private static readonly REFERRAL_KEY = 'kiloba_ref_by';

  /**
   * Save referral code to localStorage
   */
  static setRefBy(refBy: string): void {
    if (refBy && refBy.trim()) {
      localStorage.setItem(this.REFERRAL_KEY, refBy.trim());
    }
  }

  /**
   * Get referral code from localStorage
   */
  static getRefBy(): string | null {
    return localStorage.getItem(this.REFERRAL_KEY);
  }

  /**
   * Clear referral code from localStorage
   */
  static clearRefBy(): void {
    localStorage.removeItem(this.REFERRAL_KEY);
  }

  /**
   * Check if referral code exists
   */
  static hasRefBy(): boolean {
    return !!this.getRefBy();
  }

  /**
   * Extract refBy parameter from URL search params
   */
  static extractRefByFromUrl(searchParams: URLSearchParams): string | null {
    const refBy = searchParams.get('refBy');
    return refBy && refBy.trim() ? refBy.trim() : null;
  }
}
